import { render } from "./NavIcon.vue?vue&type=template&id=4e0d8ba8&scoped=true"
import script from "./NavIcon.vue?vue&type=script&lang=js"
export * from "./NavIcon.vue?vue&type=script&lang=js"

import "./NavIcon.vue?vue&type=style&index=0&id=4e0d8ba8&scoped=true&lang=postcss"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0d8ba8"]])

export default __exports__